import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';

import * as server from 'js/hooks/user/server';
import * as actions from 'js/hooks/user/store/actions';

export const useGetPaymentStatistics = (isTriggerGtm = true) => {
    const dispatch = useDispatch();

    return useCallback(async () => {
        const response = await server.getPaymentStatistics();
        const paymentsStatistics = response?.data?.payments?.statistics || {};

        dispatch(actions.userSetAttributesAction({ paymentsStatistics }));

        if (isTriggerGtm) {
            dispatcher.dispatch('user:updatePaymentStatistics');
        }

        return paymentsStatistics;
    }, [dispatch, isTriggerGtm]);
};
